import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../auth/auth';

export const noAuthGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  const userObj = localStorage.getItem(auth.AUTH_USER);
  const user = userObj ? JSON.parse(userObj) : null;

  if (!user) {
    return true;
  }

  // Allow change password route even if logged in
  if (state.url.includes('changepassword')) {
    return true;
  }

  // If must_change_password is true, user must stay on /changepassword unless going to login
  if (user.must_change_password === true || user.must_change_password === 'true' || user.must_change_password === 1) {
    if (state.url.includes('changepassword')) {
      return true;
    }
    if (state.url.includes('login')) {
      auth.updateUser(null);
      return true;
    }
    return router.createUrlTree(['/changepassword']);
  }

  return router.createUrlTree(['/dashboard']);
};
